import axios from 'axios';
import Properties from '../Tools/Properties';
import TokenService from './token.service';
import { createBrowserHistory } from 'history';

const instance = axios.create({
  baseURL: Properties.apiHostName,
  headers: {
    'Content-Type': 'application/json',
  },
});

instance.interceptors.request.use(
  (config) => {
    const token = TokenService.getLocalAccessToken();
    if (token) {
      // config.headers['Authorization'] = 'Bearer ' + token;  // for Spring Boot back-end
      config.headers['x-access-token'] = token; // for Node.js Express back-end
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    const originalConfig = err.config;

    if (originalConfig.url !== '/api/Authentication/login' && err.response) {
      // Access Token was expired
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;

        try {
          const rs = await instance.post('/api/Authentication/refreshtoken', {
            refreshToken: TokenService.getLocalRefreshToken(),
          });

          const { token } = rs.data;
          const { refreshToken } = rs.data;
          TokenService.updateLocalAccessToken(token);
          TokenService.updateLocalRefreshToken(refreshToken)

          return instance(originalConfig);
        } catch (_error) {
          createBrowserHistory.push("/login")
          return Promise.reject(_error);
        }
      }
    }

    return Promise.reject(err);
  }
);

export default instance;
